import { render, staticRenderFns } from "./EstudosPage.vue?vue&type=template&id=74bcd58f&"
import script from "./EstudosPage.vue?vue&type=script&lang=js&"
export * from "./EstudosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports